import {
  VEHICLE_LIST,
  VEHICLE_FILTER,
  VEHICLE_CREATE,
  VEHICLE_CREATE_SUCCESS,
  VEHICLE_LIST_SUCCESS,
  VEHICLE_REQUEST_FAILED,
  VEHICLE_UPDATE,
  VEHICLE_UPDATE_SUCCESS,
} from "store/vehicles/actionTypes";

const initialState = {
  vehicles: [],
  vehicleCreated: {},
  vehicleUpdated: {},
  loading: false,
  error: "",
};

const vehicle = (state = initialState, action) => {
  switch (action.type) {
    case VEHICLE_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VEHICLE_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VEHICLE_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VEHICLE_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case VEHICLE_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        vehicleCreated: action.payload,
        error: "",
      };
      break;
    case VEHICLE_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        vehicles: action.payload,
        vehicleCreated: {},
        vehicleUpdated: {},
        error: "",
      };
      break;
    case VEHICLE_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        vehicleUpdated: action.payload,
        error: "",
      };
      break;
    case VEHICLE_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default vehicle;
